import {useEffect, useState} from 'react';

export type LogoMap = Record<string, string>;

/** Key under which scripts/embed-logos.mjs stores a logo: its URL without the protocol. */
export const logoKey = (url: string) => url.replace(/^https?:/, '');

let logos: LogoMap | undefined;
let request: Promise<LogoMap> | undefined;

function loadLogos(): Promise<LogoMap> {
    if (!request) {
        // own chunk: only needed where games are shown, and cached independently of the app code
        request = import(/* webpackChunkName: "club-logos" */ '../generated/clubLogos.json')
            .then(module => module.default as LogoMap)
            .catch((): LogoMap => ({}))
            .then(map => (logos = map));
    }
    return request;
}

/** Club logos embedded at build time (see scripts/embed-logos.mjs); `undefined` while they are loading. */
export function useEmbeddedLogos(): LogoMap | undefined {
    const [map, setMap] = useState(logos);
    useEffect(() => {
        if (!map) loadLogos().then(setMap);
    }, [map]);
    return map;
}
